import { apmonth } from 'journalize';
import last from './last';

export function getSectionData(data) {
  // Gets the data
  let weekly_data = data['weekly_data'];

  // Parses data into dates
  weekly_data.forEach((d, i) => {
    d.date = new Date(Date.parse(d.date));
    d.end_date = new Date(Date.parse(d.end_date));
  });

  // Makes sure the data goes from oldest to newest
  weekly_data.sort((a, b) => a.date - b.date);

  // Gets the last array

  let lastItem = last(weekly_data);

  // Adds a not_new_deaths field to the data for the stacked bar charts
  weekly_data.forEach(function (d) {
    if (d.weekly_deaths_reported)
      d.not_new_deaths = d.deaths_nursing_homes - d.weekly_deaths_reported;
    else {
      d.not_new_deaths = 0;
      d.weekly_deaths_reported = d.deaths_nursing_homes;
    }
  });

  // Divides the data into each section by using structureData function

  return structureData(weekly_data, [
    {
      sectionName: 'Spring2020Chart',
      startDate: new Date('2020-04-15T00:00:00-05:00'),
      endDate: new Date('2020-07-09T00:00:00-05:00'),
    },
    {
      sectionName: 'SummerPeakChart',
      startDate: new Date('2020-07-15T00:00:00-05:00'),
      endDate: new Date('2020-10-01T00:00:00-05:00'),
    },
    {
      sectionName: 'WinterReboundChart',
      startDate: new Date('2020-10-07T00:00:00-05:00'),
      endDate: new Date('2021-02-11T00:00:00-05:00'),
    },
    ,
    {
      sectionName: 'Spring2021Chart',
      startDate: new Date('2021-02-18T00:00:00-05:00'),
      // Gets the latest week
      endDate: lastItem['date'],
    },
  ]);
}

// Seperates data into sections (for the weekly chart)
export function structureData(data, fields) {
  let dataTotals = [];

  fields.forEach(field => {
    var each_week = data.filter(a => {
      return a.date >= field['startDate'] && a.date <= field['endDate'];
    });

    each_week.forEach(function (row, index) {
      row.section_week_number = index + 1;
    });

    dataTotals.push({
      sectionName: field['sectionName'],
      deathWeeks: each_week,
    });
  });

  return dataTotals;
}

// Can get the start and end dates of specific sections
export function getStartEndDate(data, criteria, section, field) {
  // Filters to the right data section
  const filtered = data.filter(weeks => weeks.sectionName == section);

  // The parts options allows you to filter even further to specific ranges of weeks
  if (criteria == 'first') {
    return filtered[0].deathWeeks[0][field];
  } else if (criteria == 'last') {
    const length = filtered[0].deathWeeks.length;
    return filtered[0].deathWeeks[length - 1][field];
  }
}

export function customDateFormat(d, i, interval, props = {}) {
  let month = d.getMonth();

  let year = d.getFullYear();

  if (props.includeYear) {
    if (i % interval == 0) {
      // Only put years on April 2020 and in January 2021
      if (month == 0 || (month == 3 && year == 2020))
        return `${apmonth(new Date(d)) + ' ' + new Date(d).getFullYear()}`;
      else return `${apmonth(new Date(d))}`;
    } else return '';
  } else {
    if (i % interval == 0) return `${apmonth(new Date(d))}`;
    else return '';
  }
}
